import { cx } from '@linaria/core';
import { Tooltip } from 'components/Tooltip';
import React from 'react';
import { noop } from 'utils/fp';
import { hoverThumbStyles, shapeBoxWrapper } from './ShapePill.styles';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  thumb: React.ReactNode;
}

export function ShapePill({ thumb, children, className, ...htmlProps }: Props): JSX.Element | null {
  return (
    <div className={cx(shapeBoxWrapper, className)} {...htmlProps}>
      <Tooltip initialState={{ placement: 'right' }} data={<figure className={hoverThumbStyles}>{thumb}</figure>} data-testid="shape-pill-tooltip">
        <button type="button" onClick={noop} className="shapeButton">
          {children}
        </button>
      </Tooltip>
    </div>
  );
}
